<template lang="">
  <div class="dropdown">
    <button class="dropdown-toggle" aria-expanded="false">
      <h1 style="display: inline-flex !important">
        Ordenar por:
        <span class="font-semibold ml-1">{{ orderSelectTypeText }}</span>
        <ChevronDownIcon />
      </h1>
    </button>
    <div class="dropdown-menu w-48">
      <div class="dropdown-menu__content box p-2">
        <a
          href="javascript:;"
          class="items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 hover:font-semibold rounded-md font-poppins"
          :class="{
            'bg-gray-200': !orderSelectType,
            'font-semibold': !orderSelectType
          }"
          @click="setOption(undefined)"
        >
          Mostrar todos (Más reciente)
        </a>
        <a
          href="javascript:;"
          class="items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 hover:font-semibold rounded-md font-poppins"
          :class="{
            'bg-gray-200': orderSelectType === 'createdAtAsc',
            'font-semibold': orderSelectType === 'createdAtAsc'
          }"
          @click="setOption('createdAtAsc')"
        >
          Más antiguo
        </a>
        <a
          href="javascript:;"
          class="items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 hover:font-semibold rounded-md font-poppins"
          :class="{
            'bg-gray-200': orderSelectType === 'statusSENT',
            'font-semibold': orderSelectType === 'statusSENT'
          }"
          @click="setOption('statusSENT')"
        >
          Solicitado
        </a>
        <a
          href="javascript:;"
          class="items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 hover:font-semibold rounded-md font-poppins"
          :class="{
            'bg-gray-200': orderSelectType === 'statusIN_PROCESS',
            'font-semibold': orderSelectType === 'statusIN_PROCESS'
          }"
          @click="setOption('statusIN_PROCESS')"
        >
          En proceso
        </a>
        <a
          href="javascript:;"
          class="items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 hover:font-semibold rounded-md font-poppins"
          :class="{
            'bg-gray-200': orderSelectType === 'statusAccepted',
            'font-semibold': orderSelectType === 'statusAccepted'
          }"
          @click="setOption('statusAccepted')"
        >
          Aceptada
        </a>
        <a
          href="javascript:;"
          class="items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 hover:font-semibold rounded-md font-poppins"
          :class="{
            'bg-gray-200': orderSelectType === 'statusCounterproposal',
            'font-semibold': orderSelectType === 'statusCounterproposal'
          }"
          @click="setOption('statusCounterproposal')"
        >
          Contrapropuesta
        </a>
        <a
          href="javascript:;"
          class="items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 hover:font-semibold rounded-md font-poppins"
          :class="{
            'bg-gray-200': orderSelectType === 'statusAcceptedCounterproposal',
            'font-semibold': orderSelectType === 'statusAcceptedCounterproposal'
          }"
          @click="setOption('statusAcceptedCounterproposal')"
        >
          Cotización aceptada
        </a>
        <a
          href="javascript:;"
          class="items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 hover:font-semibold rounded-md font-poppins"
          :class="{
            'bg-gray-200': orderSelectType === 'statusRejectedCounterproposal',
            'font-semibold': orderSelectType === 'statusRejectedCounterproposal'
          }"
          @click="setOption('statusRejectedCounterproposal')"
        >
          Rechazadas
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue'
export default defineComponent({
  props: {
    orderSelectType: {
      type: String
    }
  },
  emits: ['update:orderSelectType'],
  setup() {
    const show = () => {
      cash('#programmatically-dropdown').dropdown('show')
    }
    const hide = () => {
      cash('#programmatically-dropdown').dropdown('hide')
    }
    const toggle = () => {
      cash('#programmatically-dropdown').dropdown('toggle')
    }
    return {
      show,
      hide,
      toggle
    }
  },
  methods: {
    setOption(option) {
      this.$emit('update:orderSelectType', option)
      this.hide()
    }
  },
  computed: {
    orderSelectTypeText() {
      switch (this.orderSelectType) {
        case 'createdAtAsc':
          return 'Más antiguo'
        case 'statusSENT':
          return 'Solicitado'
        case 'statusIN_PROCESS':
          return 'En proceso'
        case 'statusAccepted':
          return 'Aceptada'
        case 'statusCounterproposal':
          return 'Conta propuesta'
        case 'statusAcceptedCounterproposal':
          return 'Aceptar'
        case 'statusRejectedCounterproposal':
          return 'Rechazar'
        case 'statusCLOSE':
          return 'Terminado'
        default:
          return 'Mostrar todos (Más reciente)'
      }
    }
  }
})
</script>
